import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, WIZ_PHYSIC_POSITION, FILTER_TYPE } from '@wizeoo/akm-core-lib';
import {
  FilterComponent,
  FilterObj,
  PopUpManager,
  WizBaseCollector,
  WizBasePopUp,
  WizCheckbox,
  WizDatasource,
  WizDropItemEvent,
  WizList,
  WizPopUp,
  WizVgroup,
  WizEventManager, WizEvent,
  WizTranslationManager
} from '@wizeoo/akm-component-lib';
import { AlkEvent } from '../../../../../framework/events/alk.event';
import { PivotField } from '../../../../../manager/baselines/pivot-field.obj';
import { ALK_EVENT_TYPE, WIDGET_KIND } from '../../../../../model/enums';
import { FeiVO } from '../../../../../vo/workingdata/fei.vo';
import { PivotEditItemRenderer } from './pivot-edit-item.renderer';
import { PivotGroupEditItemRenderer } from './pivot-groupedit-item.renderer';
import { HeaderGroupEditPop } from '../header/header-groupedit.pop';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { ViewData } from '../../../../../model/view.data';
import { FeiKeyDef } from '@wizeoo/akm-compute-lib';
import { IWidget } from '../../../../../manager/widgets/i-widget';
import { cloneDeep } from 'lodash-es';
import { HeaderEditExtPop, widgetHeaderVO } from '../header/header-editext.pop';
import { Model } from '../../../../../model/model';


@Component({
  // popUp d'édition du grid en mode flat : gestion des emplacements de champs et rendu
  selector: 'pivot-base-pop',
  templateUrl: './pivot-base.pop.html',
})
export class PivotBasePop extends WizBasePopUp {
  // liste des champs et mesures disponibles
  @ViewChild('freeList', { read: WizList }) freeList: WizList;
  /** le composant de filtre principal */
  @ViewChild('mainFilter', { read: FilterComponent })
  mainFilter: FilterComponent;
  // zone globale des listes
  @ViewChild('vgDetailZone', { read: WizVgroup, static: false })
  vgDetailZone: WizVgroup;

  // dimensions demandées
  public static width: string = '1000px';
  public static height: string = 'calc(100% - 81px)';

  @ViewChild('lstFilter', { read: WizList }) lstFilter: WizList; // liste des champs de filtre
  @ViewChild('lstRow', { read: WizList }) lstRow: WizList; // liste des champs en ligne
  @ViewChild('lstColumn', { read: WizList }) lstColumn: WizList; // liste des champs en colonne
  @ViewChild('lstData', { read: WizList }) lstData: WizList; // liste des champs de donnée

  @ViewChild('lstGroup', { read: WizList }) lstGroup: WizList; // liste des groupes de colonne

  @ViewChild('cbShowDeleteCol', { read: WizCheckbox }) cbShowDeleteCol: WizCheckbox; // cb d'affichage de la colonne delete
  @ViewChild('cbShowDeleteRecurseCol', { read: WizCheckbox }) cbShowDeleteRecurseCol: WizCheckbox; // cb d'affichage de la colonne de suppression des enfants
  @ViewChild('cbShowSelectCol', { read: WizCheckbox }) cbShowSelectCol: WizCheckbox; // cb d'affichage de la colonne select
  @ViewChild('cbSelectUnique', { read: WizCheckbox }) cbSelectUnique: WizCheckbox; // cb sélection unique

  @ViewChild('lstIntegrity', { read: WizList }) lstIntegrity: WizList; // champs de contrôle de cohérence
  @ViewChild('cbDeleteIntegrity', { read: WizCheckbox }) cbDeleteIntegrity: WizCheckbox; // contrôle avant delete
  @ViewChild('cbUpdateIntegrity', { read: WizCheckbox }) cbUpdateIntegrity: WizCheckbox; // contrôle avant update


  /** Renderer de la liste */
  public renderer: any = PivotEditItemRenderer;
  public dataSource: WizDatasource<PivotField> = null; // DS des champs disponibles (au step)

  public filterDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public rowDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public columnDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public dataDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();

  public integrityDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  
  // les groupes de headers
  public groupDS: WizDatasource<PivotField> = new WizDatasource<PivotField>().setSelectionMode('none').build();
  public groupRenderer: any = PivotGroupEditItemRenderer;

  public get widget(): IWidget {
    return this.datas;
  }

  public get model(): Model {
    return this.widget?.model;
  }



  public fei: FeiVO; // les données
  public context: WidgetConfigurationObj; // la configuration
  private updateCallback: Function; // la callback pour retour et traitement dans le pivotComponent
  

  protected doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)

  protected fieldPop: WizPopUp; // la popUp d'édition des champs
  protected groupFieldPop: WizPopUp; // la popUp d'édition des groupes de colonnes


  public popUpMode: WIDGET_KIND = WIDGET_KIND.GRID; // le mode de cette pop, pour alimenter les PKD
  
  public isToolMode: boolean = true;


  constructor(public elementRef: ElementRef) {
    super();
  }

  show(): void {
    this.fei = this.widget.fei as FeiVO;
    this.isToolMode = !!this.fei.toolMode;
    this.context = cloneDeep(this.widget.context); 
    this.updateCallback = this.widget.backFromSettingsPop.bind(this.widget);

    // creation des capsules
    let prototypes: Map<string,PivotField> = new Map();
    let piv: PivotField;
    this.fei.keys.forEach(fkd => {
      piv = new PivotField(this.widget, null, fkd, null);
      piv.popUpMode = this.popUpMode;
      prototypes.set(piv.fullCode, piv);
    });

    // ajout du fake pour mettre un filtre générique
    let wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.cod = ViewData.FILTER_GENERIC;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.filter.$');
    const fakeFilter: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeFilter.order = -1;
    // pas de filtre libre en global, trop coûteux
    if(this.popUpMode !== WIDGET_KIND.GLOBAL_FILTER) {
      prototypes.set(ViewData.FILTER_GENERIC, fakeFilter);
    }

    // ajout du fake pour mettre un filtre me
    wcio = this.model.widgetEngine.newWcio(this.context.fdk, 0);
    wcio.cod = ViewData.FILTER_ME;
    wcio.lbl = WizTranslationManager.getInstance().translateKey('$.common.free.filter.me.$');
    const fakeMeFilter: PivotField = new PivotField(this.widget, wcio, null, null);
    fakeMeFilter.order = -1;
    prototypes.set(ViewData.FILTER_ME, fakeMeFilter);

    const filter = []; // alimentation du filtre de la DS principale

    filter.push(FilterObj.create('editable', '$.measure.filter.editable.only.$', FILTER_TYPE.TRUELEAN, false, 1));
    filter.push(FilterObj.create('isS', '$.measure.filter.modes.$', FILTER_TYPE.TRUELEAN, false, 2));
    filter.push(FilterObj.create('isI', '$.measure.filter.modei.$', FILTER_TYPE.TRUELEAN, false, 3));
    filter.push(FilterObj.create('isKey', '$.measure.filter.key.$', FILTER_TYPE.TRUELEAN, false, 4));
    this.mainFilter.configure(['code', 'fullCode', 'labelOrDefaultLabel'], null, Array.from(filter)).build();

    this.dataSource = new WizDatasource<PivotField>([...prototypes.values()])
      .setSelectionMode('none')
      .setSortFields([{ property: 'order', way: 'asc', numeric: true },{ property: 'groupLabel', way: 'asc', numeric: false }])
      .setFilter(this.filterFunc.bind(this))
      .build();

    // alimentation des collections depuis le contexte
    const preFilterArr: PivotField[] = [];
    const preRowArr: PivotField[] = [];
    const preColsArr: PivotField[] = [];
    const preDataArr: PivotField[] = [];
    const preIntegrityArr: PivotField[] = [];

    const preGroupArr: PivotField[] = [];

    // console.log('context', this.context);

    let pv: PivotField;
    let prototype: PivotField;
    this.context.r.forEach((confItem: WidgetConfigurationItemObj) => {
      
      prototype = prototypes.get(confItem.cod);
      if (!!prototype) {
        pv = new PivotField(this.widget, confItem, prototype.fkd, null);
        pv.usedAsRow = true;
        pv.pinned = confItem.pin; // reprise des informations de pin
        pv.popUpMode = this.popUpMode;
        preRowArr.push(pv);
      }
    });
    this.context.d.forEach((confItem: WidgetConfigurationItemObj) => {
      prototype = prototypes.get(confItem.cod);
      if (!!prototype) {
        pv = new PivotField(this.widget, confItem, prototype.fkd, null);
        pv.usedAsData = true;
        pv.pinned = confItem.pin; // reprise des informations de pin
        pv.popUpMode = this.popUpMode;
        preDataArr.push(pv);
      }

    });
    this.context.f.forEach((confItem: WidgetConfigurationItemObj) => {
      prototype = prototypes.get(confItem.cod);
      if (!!prototype) {
        pv = new PivotField(this.widget, confItem, prototype.fkd, null);
        pv.usedAsFilter = true;
        pv.popUpMode = this.popUpMode;
        preFilterArr.push(pv);
      }
    });
    this.context.c.forEach((confItem: WidgetConfigurationItemObj) => {
      prototype = prototypes.get(confItem.cod);
      if (!!prototype) {
        pv = new PivotField(this.widget, confItem, prototype.fkd, null);
        pv.usedAsColumn = true;
        pv.popUpMode = this.popUpMode;
        preColsArr.push(pv);
      }
    });

    this.context.i?.forEach((confItem: WidgetConfigurationItemObj) => {
      prototype = prototypes.get(confItem.cod);
      if (!!prototype) {
        pv = new PivotField(this.widget, confItem, prototype.fkd, null);
        pv.usedAsIntegrityControl = true;
        pv.popUpMode = this.popUpMode;
        preIntegrityArr.push(pv);
      }
    });

    this.context.g?.forEach((confItem: WidgetConfigurationItemObj) => {
      preGroupArr.push(this.model.widgetEngine.generateGroupEntry(this.widget, this.groupDS.getSource().length, confItem));
    });   

    this.filterDS.setSource(preFilterArr);
    this.rowDS.setSource(preRowArr);
    this.columnDS.setSource(preColsArr);
    this.dataDS.setSource(preDataArr);
    this.integrityDS.setSource(preIntegrityArr);

    this.groupDS.setSource(preGroupArr);

    this.feedDatasources();

    // et un tour de check pour synchroniser les isUsed dans la mainSource
    this.checkFieldIsUsed();

    this.addListeners();
  }


  /**
   * sur drop d'un PivotField, clonage pour perdre l'instance
   * @param wbc la liste source
   * @param item PivotField draggé
   * @returns le nouveau pivotField
   */
  protected cloneField(wbc: WizBaseCollector, item: PivotField): PivotField {
    const wcio: WidgetConfigurationItemObj = this.model.widgetEngine.newWcio(item.fullCode, 0);
    //const wcio: WidgetConfigurationItemObj = cloneDeep(item.contextItem);
    let pv: PivotField = new PivotField(this.widget, wcio, item.fkd, null); 
    pv.popUpMode = this.popUpMode;

    switch (wbc) {
      case this.lstFilter:
        pv.usedAsFilter = true;
        break;
      case this.lstRow:
        pv.usedAsRow = true;
        break;
      case this.lstColumn:
         pv.usedAsColumn = true;
        break;
      case this.lstData:
         pv.usedAsData = true;
        break;
      case this.lstIntegrity:
         pv.usedAsIntegrityControl = true;
        break;
    }
    return pv;
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feedDatasources(): void {
    this.lstFilter.wizDataProvider = this.filterDS;
    // unicité de champs sur les filtres
    this.lstFilter.dropControlFunction = this.FilterDropControl.bind(this);

    // aucun contrôle sur rows et datas
    this.lstRow.wizDataProvider = this.rowDS;
    this.lstColumn.wizDataProvider = this.columnDS;
    if (!!this.lstData) {
      this.lstData.wizDataProvider = this.dataDS;
      this.lstData.dropTransformFunction = this.cloneField.bind(this);
    }

    this.lstIntegrity.wizDataProvider = this.integrityDS;
    // unicité de champs sur les filtres
    this.lstIntegrity.dropControlFunction = this.integrityDropControl.bind(this);

    this.lstGroup.wizDataProvider = this.groupDS;
    this.lstGroup.dropControlFunction = this.groupDropControl.bind(this);

    // ajout du transformer sur les zones cibles
    this.lstFilter.dropTransformFunction = this.cloneField.bind(this);
    this.lstRow.dropTransformFunction = this.cloneField.bind(this);
    this.lstColumn.dropTransformFunction = this.cloneField.bind(this);
    this.lstIntegrity.dropTransformFunction = this.cloneField.bind(this);

    this.cbDeleteIntegrity.wizChecked = !!this.context.idel;
    this.cbUpdateIntegrity.wizChecked = !!this.context.iupd;


    this.cbShowDeleteCol.wizChecked = !!this.context.shd;
    this.cbShowDeleteRecurseCol.wizChecked = !!this.context.shrd;
    this.cbShowSelectCol.wizChecked = !!this.context.shs;
    this.cbSelectUnique.wizChecked = !!this.context.shsu;
  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    WizEventManager.addListener(this, this.mainFilter, WIZ_EVENT_TYPE.FILTER, this.doFilter); // ecouteur sur le filtre de la DS principale
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DRAG_DROPPED, this.updateModel);
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DRAG_MOVED, this.updateModel);
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.DELETE, this.updateModel);

    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_FIELD, this.showConfPop); // demande de conf d'un champ
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.PIVOT_CONFIGURE_GROUP_FIELD, this.showGroupConfPop); // demande de conf d'un champ
  }

  /** validation du contenu */
  public doValid(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** modification du context pour retour sur la base des params */
  public updateContext(): void {

    // prendre le champ & le field. Les 2 doivent correspondre (filtre multiple)
    const filterMap: Map<string, WidgetConfigurationItemObj> = new Map<string, WidgetConfigurationItemObj>();
    if (this.context.f) {
      this.context.f.forEach((wcio: WidgetConfigurationItemObj) => {
        filterMap.set(wcio.cod + wcio.fdvf, wcio);
      });
    }

    this.model.widgetEngine.wcioInitArrays(this.context); // init des [crdfig]

    let idx: number = 1; // positions
    let confItem: WidgetConfigurationItemObj;
    this.rowDS.getSource().forEach((item: PivotField) => { // rows
      
      confItem = this.model.widgetEngine.newWcio(item.fullCode, idx);
      confItem.lbl = item.labelOrDefaultLabel;
      confItem.pin = item.pinned; // fkd.pinned;
      confItem.fdvf = item.fdvField;
      confItem.heada = item.headerAlign;
      confItem.pgrp = item.parentGroup; // colonne d'appartenance
      confItem.cella = item.cellAlign;
      confItem.fdvSearch = item.fdvSearch;
      confItem.mems = item.massSplit;
      this.model.widgetEngine.wcioColParams(confItem, item.colRezisable, item.colMinSize, item.colSize, item.exportable, item.hiddenCol); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style, item.headerStyle, item.cellStyle); // format & style
      
      confItem.headInherit = item.headInherit;
      confItem.masterRowStyle = item.styleConso;

      confItem.totAgg = item.totalAgregateFunc;
      confItem.totAggM = item.totalAgregateMeasure;
      confItem.totFmt = item.totalFormat;
      confItem.cauto = item.colAutoSize;

      confItem.pmdexParams = item.pmdexParams;

      this.context.r.push(confItem);
      idx++;
    });

    this.columnDS.getSource().forEach((item: PivotField) => { // colonnes
      
      confItem = this.model.widgetEngine.newWcio(item.fullCode, idx);
      confItem.lbl = item.labelOrDefaultLabel;
      confItem.fdvf = item.fdvField;
      confItem.heada = item.headerAlign;
      this.model.widgetEngine.wcioColParams(confItem, item.colRezisable, item.colMinSize, item.colSize, item.exportable, item.hiddenCol); // taille de col pour pivot.revert
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style, item.headerStyle, null, item.headColorField, item.headSubField); // format & style
 
      confItem.totAgg = item.totalAgregateFunc;
      confItem.totAggM = item.totalAgregateMeasure;
      confItem.totFmt = item.totalFormat;
      confItem.cauto = item.colAutoSize;
      confItem.pmdexParams = item.pmdexParams;

      confItem.colTot = item.colTot;
      confItem.colTotLabel = item.colTotLabel;

      this.context.c.push(confItem);
      idx++;
    });

    this.filterDS.getSource().forEach((item: PivotField) => { // filters
    
      confItem = this.model.widgetEngine.newWcio(item.fullCode, idx);
      confItem.lbl = item.labelOrDefaultLabel;
      confItem.fdvf = item.fdvField;
      confItem.fdvSearch = item.fdvSearch;
      confItem.filtHide = item.filtHide;
      confItem.mandatory = item.mandatoryFilter;
      confItem.strict = item.strictFilter;
      confItem.step = item.step;
      confItem.filtOnEx = item.filtOnlyExist;
      this.model.widgetEngine.wcioColParams(confItem, false, item.colMinSize, item.colSize); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style); // format & style
       
      confItem.totAgg = item.totalAgregateFunc;
      confItem.totAggM = item.totalAgregateMeasure;
      confItem.totFmt = item.totalFormat;

      if (filterMap.has(confItem.cod + confItem.fdvf)) { // reprise des filtres existants 
        confItem.sel = filterMap.get(confItem.cod + confItem.fdvf).sel;
        confItem.filtExp = filterMap.get(confItem.cod + confItem.fdvf).filtExp;
      }
      this.context.f.push(confItem);
      idx++;
    });

    this.dataDS.getSource().forEach((item: PivotField) => { // Datas
      
      confItem = this.model.widgetEngine.newWcio(item.fullCode, idx);
      confItem.lbl = item.labelOrDefaultLabel;
      confItem.ro = item.readOnly;
      confItem.mems = item.massSplit;
      confItem.fdvf = item.fdvField;
      confItem.pgrp = item.parentGroup; // colonne d'appartenance
      confItem.heada = item.headerAlign;
      confItem.cella = item.cellAlign;
      confItem.fdvSearch = item.fdvSearch;
      confItem.pin = item.pinned; // fkd.pinned;
      this.model.widgetEngine.wcioColParams(confItem, item.colRezisable, item.colMinSize, item.colSize, item.exportable, item.hiddenCol); // taille de col
      this.model.widgetEngine.wcioStyleParams(confItem, item.format, item.style, item.headerStyle, item.cellStyle); // format & style
      
      confItem.headInherit = item.headInherit;

      confItem.totAgg = item.totalAgregateFunc;
      confItem.totAggM = item.totalAgregateMeasure;
      confItem.totFmt = item.totalFormat;
      confItem.msty = item.measureStyle;
      confItem.cauto = item.colAutoSize;
      
      confItem.pmdexParams = item.pmdexParams;

      if (this.context.pm) {
        confItem.agg = item.aggOrDefaultFunc();
      }
      
      this.context.d.push(confItem);
      idx++;
    });

    this.integrityDS.getSource().forEach((item: PivotField) => { // contrôle d'intégrité
      confItem = this.model.widgetEngine.newWcio(item.fullCode, idx);
      this.context.i.push(confItem);
      idx++;
    });


    idx= 0;
    this.groupDS.getSource().forEach((item: PivotField) => { // colonnes custom
      confItem = this.model.widgetEngine.newWcio(item.code.split(ViewData.CONTEXT_SEPARATOR)[0], idx);
      confItem.lbl = item.labelOrDefaultLabel;
      confItem.hsty = item.headerStyle;
      confItem.pgrp = item.parentGroup;
      confItem.heada = item.headerAlign;
      confItem.cella = item.cellAlign;
      this.context.g.push(confItem);
      idx++;
    });   

    this.context.shd = this.cbShowDeleteCol.wizChecked; // affichage du delete
    this.context.shrd = this.cbShowDeleteRecurseCol.wizChecked; // affichage du delete sur enfant
    this.context.shs = this.cbShowSelectCol.wizChecked; // affichage du select
    this.context.shsu = this.cbSelectUnique.wizChecked; // affichage du select unique


    this.context.idel = this.cbDeleteIntegrity.wizChecked; // contrôle sur delete
    this.context.iupd = this.cbUpdateIntegrity.wizChecked; // contrôle sur update
  }

  public onHide() {
    if (this.doSaveFlag) {
      if (!!this.updateCallback) {
        this.updateContext();
        this.updateCallback(this.context);
      }
    }
  }

  /* ##############################################################################
                   filtre et rendu de la DS principale
     ############################################################################## */

  /**
   * modification du filtre
   * @param e WizEvent
   */
  protected doFilter(e: WizEvent): void {
    this.dataSource.refresh();
  }

  // filterFunc de la collection principale
  protected filterFunc(item: PivotField): boolean {
    return this.mainFilter.checkVisible(item);
  }

  /**
   * détection de la position des fields. Alimentation de la donnée sur dataSource (celle du FEI)
   * pour signaler les champs utilisés
   */
  protected checkFieldIsUsed(): void {
    // map pour les 4 collections
    const filterMap: Map<string, PivotField> = new Map(this.filterDS.getSource().map((item) => [item.fullCode, item]));
    const rowMap: Map<string, PivotField> = new Map(this.rowDS.getSource().map((item) => [item.fullCode, item]));
    const columnMap: Map<string, PivotField> = new Map(this.columnDS.getSource().map((item) => [item.fullCode, item]));
    const dataMap: Map<string, PivotField> = new Map(this.dataDS.getSource().map((item) => [item.fullCode, item]));

    this.dataSource.getSource().forEach((item: PivotField) => {
      item.usedAsFilter = filterMap.has(item.fullCode);
      item.usedAsRow = rowMap.has(item.fullCode);
      item.usedAsColumn = columnMap.has(item.fullCode);
      item.usedAsData = dataMap.has(item.fullCode);
    });
    this.dataSource.refresh();
  }

  /* ##############################################################################
                  modification du contenu de l'une des zones
    ############################################################################## */

  /**
   * Modification du modèle
   * @param e Evenement model change
   */
  protected updateModel(e: WizEvent): void {

    let droppedPivot: PivotField = e.value;
    let targetList: WizList = e.component as WizList;
    switch(targetList) {
      case this.lstData:
        droppedPivot.usedAsData = true;
      break;
      case this.lstRow:
        droppedPivot.usedAsRow = true;
      break;
      case this.lstColumn:
        droppedPivot.usedAsColumn = true;
      break;
      case this.lstFilter:
        droppedPivot.usedAsFilter = true;
      break;
      case this.lstIntegrity:
        droppedPivot.usedAsIntegrityControl = true;
      break;
    }

    this.checkFieldIsUsed(); // synchro du rendu de la liste principale (icone oeil pour Used)
  }

  /**
   * demande d'affichage de la popUp de configuration des champs
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
  protected showConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.fieldPop)) {
      // suppression de l'instance existante
      this.fieldPop.hide();
    }

    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.fieldPop = new WizPopUp( HeaderEditExtPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      HeaderEditExtPop.baseWidth + 'px',
      HeaderEditExtPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.fieldPop,
      fei: this.fei,
      context: this.context,
      updateCallback: this.backFromFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: this.popUpMode,
      widget: this.widget,
      currentGroups: this.groupDS?.getSource()
    }

    // alimentation des datas
    this.fieldPop.datas = datas;

    this.fieldPop.show();
  }

  /**
   * retour d'édition de champ
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
  }

  /* ##############################################################################
                   contrôles de cohérence du drag'n'drop
     ############################################################################## */

  /** Fonction de controle du drop */
  public FilterDropControl({ item, dragSource }: WizDropItemEvent): boolean {
    const field: PivotField = item.data as PivotField;
    if (dragSource === this.lstFilter) {
      // déplacement self dans la liste de filtre
      return true; // on laisse passer
    }

    if(!!field.isFreeFilter) {
      for (const ff of this.filterDS.getSource()) {
        if (ff.code === field.code) {// une seule fois pour chaque filtre free
          return false;
        }
      }
      return true;
    }


    return true;
  }

  /** Fonction de controle du drop sur zone intégrité */
  public integrityDropControl({ item, dragSource }: WizDropItemEvent): boolean {   
    const pkd: FeiKeyDef = (item.data as PivotField).fkd;
    
    if (dragSource === this.lstIntegrity) {
      // déplacement self dans la liste de filtre
      return true; // on laisse passer
    }

    // uniquement des mesures
    if (!pkd.isMeasure) {
      return false;
    }

    // sinon, contrôle d'unicité du filtre
    for (const otherpkd of this.filterDS.getSource()) {
      if (pkd.fullCode === otherpkd.fullCode) {
        return false;
      }
    }
    return true;
  }

  /** Fonction de controle du drop sur zone groupe de colonnes */
  public groupDropControl({ item, dragSource }: WizDropItemEvent): boolean {   
    if (dragSource === this.lstGroup) { // déplacement self
      return true; // on laisse passer
    }
    return false;
  }

  /* ##############################################################################
                  gestion des groupes de colonnes custom en mode grid
    ############################################################################## */


  /** ajout d'un groupe de colonnes */
  public addGroup(): void {
    // console.log('addGroup');
    this.groupDS.addItem(this.model.widgetEngine.generateGroupEntry(this.widget, this.groupDS.getSource().length));
  }

  /**
   * demande d'affichage de la popUp de configuration des champs
   * @param e alkEvent, data = [pivotField, wizBaseCollector]
   */
   protected showGroupConfPop(e: AlkEvent): void {
    if (PopUpManager.exist(this.groupFieldPop)) {
      // suppression de l'instance existante
      this.groupFieldPop.hide();
    }

    // ouverture de la pop. Data[fei, context, WizbaseCollector, PivotField, callback]
    this.groupFieldPop = new WizPopUp( HeaderGroupEditPop, true, false, WIZ_PHYSIC_POSITION.MIDDLE_CENTER,
      HeaderGroupEditPop.baseWidth + 'px',
      HeaderGroupEditPop.baseHeight + 'px');

    // construction des données
    const datas: widgetHeaderVO = {
      popReference: this.groupFieldPop,
      fei: this.fei,
      context: this.context,
      updateCallback: this.backFromGroupFieldPop.bind(this),
      pivotField: e.data[0],
      baseCollector: e.data[1],
      popUpMode: this.popUpMode,
      widget: this.widget,
      currentGroups: this.groupDS?.getSource()
    }

    // alimentation des datas
    this.groupFieldPop.datas = datas;

    this.groupFieldPop.show();
  }

  /**
   * retour d'édition de groupe de colonnes
   * @param wbc la collection d'origine, transmise par l'event de showConfPop
   * @param pf PivotField
   */
  protected backFromGroupFieldPop(wbc: WizBaseCollector, pf: PivotField): void {
    wbc.wizDataProvider.refresh();
    this.lstData.wizDataProvider.refresh();
  }

}
